import { render, staticRenderFns } from "./HeaderBanner.vue?vue&type=template&id=60928ff2"
import script from "./HeaderBanner.vue?vue&type=script&lang=js"
export * from "./HeaderBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports